"use client";
import { Link } from "@/app/components/lib/navigation/Link";
import useProductPopup from "@/hooks/useProductPopup";
import {
  Config_Customize,
  IProduct_Scrollable_Tabs_Config_Customize,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import { useIsSmallScreen } from "./useIsSmallScreen";

interface Props extends React.HTMLProps<HTMLDivElement> {
  isEvent: boolean;
  slug: string;
  Customize?: Config_Customize;
}
const ProductClick: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  isEvent,
  slug,
  Customize,
  ...props
}) => {
  const { handleOpenPopup } = useProductPopup();
  const isHor = useIsSmallScreen() && (isEvent ?? false);
  const saveScrollPosition = () => {
    sessionStorage.setItem("scrollPosition", window.scrollY.toString());
  };
  const handleProductClick = () => {
    saveScrollPosition();
  };
  const positionImgIfSTByFlexOrder = () => {
    if (!isEvent) {
      return 0;
    }
    return (Customize as IProduct_Scrollable_Tabs_Config_Customize)
      ?.image_position !== "start" && isHor
      ? 0
      : 0;
  };
  return (
    <div {...props} style={{ order: positionImgIfSTByFlexOrder() }}>
      {isEvent ? (
        <div onClick={() => handleOpenPopup({ productID: slug })}>
          {children}
        </div>
      ) : (
        <Link
          skipCheckingForLang
          prefetch={false}
          href={`/products/${slug}`}
          onClick={handleProductClick}
        >
          {children}
        </Link>
      )}
    </div>
  );
};

export default ProductClick;
